import { useQuery } from '@hooks/reactQuery';

import { getRUStatusDashboardCarriersState } from '@api/ruStatusDashboard';

import { extractQueryParams } from '@utils/common';

import { IRUNetworkElementId } from '@interfaces/ruStatusDashboard/dto/ruStatusDashboardDTO';
import { ICarrier } from '@interfaces/ruStatusDashboard/ruStatusDashboard';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_DASHBOARD_ACTIVE_CARRIER_STATE } from '@constants/queryKeys';

interface IUseQueryRUDashboardStatusCarriersStateReturned {
	ruDashboardStatusCarriersState: ICarrier[];
	isLoadingRUDashboardStatusCarriers: boolean;
}

export const useQueryRUDashboardStatusCarriersState = (
	params: IRUNetworkElementId,
): IUseQueryRUDashboardStatusCarriersStateReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<ICarrier[]>({
		queryKey: [RU_DASHBOARD_ACTIVE_CARRIER_STATE, params],
		queryFn: extractQueryParams(getRUStatusDashboardCarriersState),
		allowedRoles: [
			EUserRoles.smoLightUpdater,
			EUserRoles.smoLightViewer,
		],
		...refetchOptions,
	});

	return {
		ruDashboardStatusCarriersState: data || [],
		isLoadingRUDashboardStatusCarriers: isInitialLoading,
	};
};
